import {
	SET_FORM_STATE
} from '../actions/CapacityPRBBlackListActions';

const initialState = {
	formState:
	{
		isValid: false,
		values: {},
		touched: {},
		errors: {}
	},
};

const CapacityPRBBlackListReducers = (state = initialState, action) => {
	switch (action.type) {
					case SET_FORM_STATE: {
						return {
							...state,
							formState: { ...state.formState, ...action.formState }
						};
					}
					default: {
						return state;
					}
	}
};

export default CapacityPRBBlackListReducers;
